import type { RowChangeTone } from "~/utils/getRowChangeDisplay";

import { type ISpreadRange, SpreadBand } from "./marketQualityTypes";

const TIGHT_BELOW_CENTS = 2;
const MODERATE_BELOW_CENTS = 6;
const VERY_WIDE_OVER_FRACTION = 0.1;

export const toTenthsOfCent = (spread: number): number =>
  Math.round(spread * 1000) / 10;

export const isSpreadRange = ({ min, max }: ISpreadRange): boolean =>
  toTenthsOfCent(min) !== toTenthsOfCent(max);

export const getSpreadBand = (spread: number): SpreadBand => {
  if (spread > VERY_WIDE_OVER_FRACTION) {
    return SpreadBand.VERY_WIDE;
  }

  const cents = toTenthsOfCent(spread);

  if (cents < TIGHT_BELOW_CENTS) {
    return SpreadBand.TIGHT;
  }

  return cents < MODERATE_BELOW_CENTS ? SpreadBand.MODERATE : SpreadBand.WIDE;
};

export const toneBySpreadBand: Record<SpreadBand, RowChangeTone> = {
  [SpreadBand.TIGHT]: "up",
  [SpreadBand.MODERATE]: "none",
  [SpreadBand.WIDE]: "down",
  [SpreadBand.VERY_WIDE]: "down",
};
